import { graphql } from '@/generated/gql';

export const SUPPLIER_RISK_CATEGORY_SCORE_WIDGET_QUERY = graphql(/* GraphQL */ `
  query SupplierRiskCategoryScoreWidget($id: UUID!) {
    cataclysm {
      supplier(id: $id) {
        id
        score
        categories {
          id
          name
          score
        }
      }
    }
  }
`);
